import React from 'react';
import PropTypes from 'prop-types';
import {
  TabbedView,
  Tab,
  TabList,
  TabPanel,
} from 'components/shared/TabbedView';
import { useFeatureFlags } from 'components/shared/hooks';
import GradingStationList from './GradingStationList';

export const TABS = {
  LESSONS: 'Lessons',
  DEMONSTRATIONS: 'Demonstrations',
};
const TABS_ARRAY = [TABS.LESSONS, TABS.DEMONSTRATIONS];

const GradingStationTabs = ({ tab, setTab, ...props }) => {
  const hasDemonstrations = props.demonstrationProgresses.length > 0;
  return (
    <TabbedView
      selectedIndex={TABS_ARRAY.indexOf(tab)}
      onSelect={index => setTab(TABS_ARRAY[index])}
    >
      <TabList>
        <Tab customColor>{t('grades.tabs.lessons')}</Tab>
        {hasDemonstrations && (
          <Tab customColor>{t('grades.tabs.demonstrations')}</Tab>
        )}
      </TabList>
      <TabPanel>
        <GradingStationList {...props} />
      </TabPanel>
      <TabPanel>
        <GradingStationList
          {...props}
          currentGradableName={null}
          currentGradableOptions={null}
          markProgressGraded={props.markDemonstrationProgressGraded}
          progresses={props.demonstrationProgresses}
          hasProgresses={hasDemonstrations}
        />
      </TabPanel>
    </TabbedView>
  );
};

GradingStationTabs.propTypes = {
  demonstrationProgresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      demonstration: PropTypes.shape({
        id: PropTypes.number,
        prompt: PropTypes.string,
        givenAnswer: PropTypes.string,
        noteToGraders: PropTypes.string,
        feedbackCriteria: PropTypes.arrayOf(
          PropTypes.shape({
            id: PropTypes.number,
            criterion_id: PropTypes.number,
            name: PropTypes.string,
            description: PropTypes.string,
            score: PropTypes.number,
          }),
        ),
      }),
    }),
  ),
  hasProgresses: PropTypes.bool,
  filtersLoading: PropTypes.bool,
  progresses: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
    }),
  ),
  currentGradableName: PropTypes.string,
  currentGradableOptions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ),
  ziggeoApiKey: PropTypes.string,
  currentUser: PropTypes.string,
  stalenessThreshold: PropTypes.number,
  gradableType: PropTypes.string,
  markProgressGraded: PropTypes.func,
  markDemonstrationProgressGraded: PropTypes.func,
};

const GradingStationTabsContainer = props => {
  const hasCertifications = useFeatureFlags(['certifications']);
  return hasCertifications || props.demonstrationProgresses.length ? (
    <GradingStationTabs {...props} />
  ) : (
    <GradingStationList {...props} />
  );
};

export default GradingStationTabsContainer;
